import { createContext, useContext } from 'react';

type PageLayoutContextShape = {
  hasSidebar: boolean;
  hasFixedFooter: boolean;
};

/**
 * This context stores objects and properties which are required for the components nested in the PageLayout - PageSection, PageHeader, PageFooter etc.
 *
 * @param hasSidebar - whether the page has layout with a sidebar
 * @param hasFixedFooter - whether the page has fixed footer
 */
export const PageLayoutContext = createContext<PageLayoutContextShape>({
  hasSidebar: true,
  hasFixedFooter: false,
});

export const usePageLayoutContext = (): PageLayoutContextShape => useContext(PageLayoutContext);
